import script from "./systemConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./systemConfig.vue?vue&type=script&setup=true&lang=js"

import "./systemConfig.vue?vue&type=style&index=0&id=30b1090b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b1090b"]])

export default __exports__